import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import { EntityLink } from "scmp-app/components/entity-link";
import type { magazinesStyleArticleMoreOnThisContentItemContent$key } from "scmp-app/queries/__generated__/magazinesStyleArticleMoreOnThisContentItemContent.graphql";

import { Container, Headline } from "./styles";

export type Props = ContentItemRenderVariantProps & {
  reference: magazinesStyleArticleMoreOnThisContentItemContent$key;
};

export const ContentItemMagazinesStyleArticleMoreOnThis: FunctionComponentWithRef<
  Props,
  HTMLDivElement
> = ({ className, ref: forwardReference, reference }) => {
  const article = useFragment(
    graphql`
      fragment magazinesStyleArticleMoreOnThisContentItemContent on Content {
        ...entityLink
        ...helpersCheckIsMainTopicContent
        ...hooksContentItemProvidersContent
          @arguments(withCoverImage: true, withCoverImageSize768x768: true, withHeadline: true)
      }
    `,
    reference,
  );
  const providers = useContentItemProviders(article);

  return (
    <Container className={className} ref={forwardReference}>
      <EntityLink reference={article}>
        {providers.coverImage({
          responsiveVariants: {
            desktopUp: "size768x768",
            mobileUp: "size768x768",
            tabletUp: "size768x768",
          },
        })}

        <Headline>{providers.headline({ preferSocialHeadline: true })}</Headline>
      </EntityLink>
    </Container>
  );
};

ContentItemMagazinesStyleArticleMoreOnThis.displayName =
  "ContentItemMagazinesStyleArticleMoreOnThis";
